import { render } from "./languageTranslation.vue?vue&type=template&id=2c20c1f5&scoped=true"
import script from "./languageTranslation.vue?vue&type=script&lang=js"
export * from "./languageTranslation.vue?vue&type=script&lang=js"

import "./languageTranslation.vue?vue&type=style&index=0&id=2c20c1f5&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c20c1f5"]])

export default __exports__